// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.stage.monatest.icu/auto-open-api-spec.yaml 1.8.2
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2025-03-24T16:03:15.464582+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializes Notifications from database.
 * @see #/components/schemas/Notification - reference to schema in open-api-spec.yaml
 * @since 2025-03-24T16:03:15.464582+02:00[Europe/Kiev]
 * @version 1.8.2
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface Notification {
    /**
     * ID of Notification.
     * @dataFormat uuid
     */
    id: string;
    /**
     * Stream ID of Notification.
     * @dataFormat uuid
     */
    encounter_id: string;
    /**
     * Source of Notification.
     *
     */
    source: string;
    /**
     * Title of Notification.
     *
     */
    title: string;
    /**
     * Text of Notification.
     *
     */
    body: string;
    /**
     * Navigate Action of Notification.
     * @dataFormat uri
     */
    navigate_to?: string;
    /**
     * Sub title of Notification.
     *
     */
    sub_title?: string;
    /**
     * Read Status of the notification.
     *
     */
    read_status: boolean;
    /**
     * Read By of the notification.
     *
     */
    read_by?: string;
    /**
     * Image url of the notification
     *
     */
    img_url?: string;
    /**
     * AI source of the notification.
     *
     */
    ai_source?: string;
    /**
     * AI reason of the notification.
     *
     */
    ai_reason?: string;
    /**
     * AI feedback url of the notification.
     *
     */
    feedback_url?: string;
    /**
     * Is notification generated by AI.
     *
     */
    is_ai?: boolean;
    /**
     * Created At of the notification.
     * @dataFormat date-time
     */
    readonly created_at: string;
    /**
     * Updated At of the notification.
     * @dataFormat date-time
     */
    readonly updated_at: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for Notification
 */
export namespace Notification {
    /**
     * Notification Frontend Model with camelCase properties
     * @since 2025-03-24T16:03:15.464582+02:00[Europe/Kiev]
     * @version 1.8.2
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * ID of Notification.
         * @dataFormat uuid
         */
        id: string;
        /**
         * Stream ID of Notification.
         * @dataFormat uuid
         */
        encounterId: string;
        /**
         * Source of Notification.
         * @type string (`dataFormat` is missing)
         */
        source: string;
        /**
         * Title of Notification.
         * @type string (`dataFormat` is missing)
         */
        title: string;
        /**
         * Text of Notification.
         * @type string (`dataFormat` is missing)
         */
        body: string;
        /**
         * Navigate Action of Notification.
         * @dataFormat uri
         */
        navigateTo?: string;
        /**
         * Sub title of Notification.
         * @type string (`dataFormat` is missing)
         */
        subTitle?: string;
        /**
         * Read Status of the notification.
         * @type boolean (`dataFormat` is missing)
         */
        readStatus: boolean;
        /**
         * Read By of the notification.
         * @type string (`dataFormat` is missing)
         */
        readBy?: string;
        /**
         * Image url of the notification
         * @type string (`dataFormat` is missing)
         */
        imgUrl?: string;
        /**
         * AI source of the notification.
         * @type string (`dataFormat` is missing)
         */
        aiSource?: string;
        /**
         * AI reason of the notification.
         * @type string (`dataFormat` is missing)
         */
        aiReason?: string;
        /**
         * AI feedback url of the notification.
         * @type string (`dataFormat` is missing)
         */
        feedbackUrl?: string;
        /**
         * Is notification generated by AI.
         * @type boolean (`dataFormat` is missing)
         */
        isAi?: boolean;
        /**
         * Created At of the notification.
         * @dataFormat date-time
         */
        @TransformDate() readonly createdAt: Date;
        /**
         * Updated At of the notification.
         * @dataFormat date-time
         */
        @TransformDate() readonly updatedAt: Date;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * Notification DTO
     * Transforms Notification model from/to API object
     * @since 2025-03-24T16:03:15.464582+02:00[Europe/Kiev]
     * @version 1.8.2
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend Notification model */
        static toModel(obj: Notification): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend Notification model */
        static toApi(obj: Model): Notification {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as Notification;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
